import instance from "./instance";
import {API_URL} from "../config/api";
import {getDriveTypeFix} from "./help";

const extName = require('ext-name');

export default class DriveService {

    static putToS3 = async (url, data, onUploadProgress) => {
        try {
            let headerType;
            let type = extName(data.name);
            if (type.length === 0) {
                headerType = 'model/ply'
            } else if (type[0].ext === "obj") {
                headerType = 'model/obj'
            } else {
                headerType = type[0].mime;
            }
            return await instance.put(url, data, {headers: {'Content-Type': headerType}, onUploadProgress});
        } catch (e) {
            console.error(e);
        }
    }

    static getS3BucketUrl = async (putData, driveType) => {
        try {
            const res = await instance.put(API_URL.DRIVE_FILE + getDriveTypeFix(driveType), putData);
            return res.data.data.result;
        } catch (e) {
            // console.log(e);
        }
    }

    static createFolder = async (postData, driveType) => {

        const res = await instance.post(API_URL.DRIVE_FOLDER + getDriveTypeFix(driveType), postData);
        // console.log(res);
        try {
            if (res.status === 200) {
                return res.data.data.result;
            }
        } catch (e) {
            console.error(e);
        }

    }

    static getFileTree = async (folder = "", driveType = "") => {

        const url = API_URL.DRIVE_FILE + (driveType && driveType.length > 0 ? `/${driveType}` : "") + (folder ? "?folder=" + encodeURIComponent(folder) : "");
        const res = await instance.get(url);
        // console.log(res);
        try {
            if (res.status === 200) {
                return res.data.data.result;
            }
        } catch (e) {
            console.error(e);
        }

    }

    static getUser = async () => {
        const res = await instance.get(API_URL.DRIVE_USER);
        // console.log(res);
        try {
            if (res.status === 200) {
                return res.data.data.result;
            }
        } catch (e) {
            console.error(e);
        }


    }

    static copy = async ({folder, folder_new, move, driveType}) => {
        const res = await instance.put(API_URL.DRIVE_FOLDER + getDriveTypeFix(driveType) + '/copy', {
            folder, folder_new, move
        });
        // console.log(res);
        try {
            if (res.status === 200) {
                return res.data.data.result;
            }
        } catch (e) {
            console.error(e);
        }
    }

    static delete = async (folder, driveType) => {
        // console.log("delete-folder-path", folder);
        const res = await instance.delete(API_URL.DRIVE_FOLDER + getDriveTypeFix(driveType) + '?folder=' + encodeURIComponent(folder));
        // console.log(res);
        try {
            if (res.status === 200) {
                return true
            }
        } catch (e) {
            console.error(e);
        }
    }

    static rename = async (params) => {
        const {folder, folder_new, driveType} = params;
        const res = await instance.patch(API_URL.DRIVE_FOLDER + getDriveTypeFix(driveType), {folder, folder_new});
        // console.log(res);
        try {
            if (res.status === 200) {
                return res.data.data.result;
            }
        } catch (e) {
            console.error(e);
        }
    }

}